export default {
  googlePlayImageAlt: {
    id: 'google_play_image_alt',
    defaultMessage: 'Get it on Google Play for the Android app user',
  },
  appStoreImageAlt: {
    id: 'apple_store_image_alt',
    defaultMessage: 'Download on the App Store for the iPhone app user',
  },
}
